import { useMainStore } from "@/store";
import { defineComponent } from "vue";

export default defineComponent({
    computed: {
        specialties(): any[] {
            return useMainStore().session?.occupations || []
        }
    }
})